const BODY_LIMIT = 100;
const ICON = '/brand-assets/notification-icon.png';

const isSupported = () => 'Notification' in window && !!window.Notification;

export const getDesktopNotificationPermission = () =>
  isSupported() ? window.Notification.permission : 'unsupported';

export const requestDesktopNotificationPermission = async () => {
  if (!isSupported()) return 'unsupported';
  return window.Notification.requestPermission();
};

export const buildDesktopNotification = (
  message,
  { newMessageTitle, attachmentBody }
) => {
  const {
    account_id: accountId,
    conversation_id: conversationId,
    content,
    sender,
  } = message;

  return {
    title: sender?.name || newMessageTitle,
    options: {
      body: content ? content.slice(0, BODY_LIMIT) : attachmentBody,
      tag: `conversation_${accountId}_${conversationId}`,
      renotify: true,
      icon: ICON,
    },
  };
};

export const buildTestNotification = ({ title, body }) => ({
  title,
  options: { body, tag: 'desktop_popup_test', renotify: true, icon: ICON },
});

// Best effort: some browsers (Android Chrome) refuse page notifications and throw.
// A pop-up must never stop the incoming message from reaching the conversation.
export const showDesktopNotification = ({ title, options }, onClick) => {
  try {
    const notification = new window.Notification(title, options);
    notification.onclick = () => {
      onClick();
      notification.close();
    };
  } catch {
    // Nothing to show on this browser; the sound and the unread counts still alert.
  }
};
